const textFieldModalFilter = {
  action: 'Ação',
  problem: 'Problema',
};

export default textFieldModalFilter;
